<div class="documents-dialog">
    <div class="dialog-header">
        <h2>Documents: {{ amcoId }}.{{ consignmentNumber }}</h2>
        <button
            mat-icon-button
            (click)="onClose()"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>


    <div class="documents-table">
        <div *ngIf="isLoading$ | async" class="loading-spinner">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <table
            mat-table
            [dataSource]="documents"
            *ngIf="(isLoading$ | async) === false"
        >
            <ng-container matColumnDef="no">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >
                    No
                </th>
                <td
                    mat-cell
                    *matCellDef="let doc"
                    [class.optimistic-doc]="isOptimisticDocument(doc)"
                >
                    {{doc.no}}
                </td>
            </ng-container>


            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >
                    Name
                </th>
                <td
                    mat-cell
                    *matCellDef="let doc"
                    [class.optimistic-doc]="isOptimisticDocument(doc)"
                >
                    {{doc.name}}
                </td>
            </ng-container>


            <ng-container matColumnDef="dateCreated">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >
                    Date created
                </th>
                <td
                    mat-cell
                    *matCellDef="let doc"
                    [class.optimistic-doc]="isOptimisticDocument(doc)"
                >
                    {{doc.dateCreated | date:'M/d/yyyy HH:mm'}}
                </td>
            </ng-container>


            <ng-container matColumnDef="type">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >
                    Type
                </th>
                <td
                    mat-cell
                    *matCellDef="let doc"
                    [class.optimistic-doc]="isOptimisticDocument(doc)"
                >
                    {{doc.type}}
                </td>
            </ng-container>


            <ng-container matColumnDef="documentType">
                <th mat-header-cell *matHeaderCellDef>Document Category</th>
                <td mat-cell *matCellDef="let doc" [class.optimistic-doc]="isOptimisticDocument(doc)">{{doc.documentType}}</td>
            </ng-container>

            <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef>Created By</th>
                <td mat-cell *matCellDef="let doc" [class.optimistic-doc]="isOptimisticDocument(doc)">{{doc.createdBy || ''}}</td>
            </ng-container>

            <ng-container matColumnDef="size">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >
                    Size
                </th>
                <td
                    mat-cell
                    *matCellDef="let doc"
                    [class.optimistic-doc]="isOptimisticDocument(doc)"
                >
                    {{doc.size}}
                </td>
            </ng-container>


            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                ></th>
                <td
                    mat-cell
                    *matCellDef="let doc"
                >
                    <!-- Show processing indicator for optimistic documents -->
                    <div *ngIf="isOptimisticDocument(doc)" class="processing-indicator">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span class="processing-text">Processing...</span>
                    </div>

                    <!-- Show normal actions for non-optimistic documents -->
                    <div *ngIf="!isOptimisticDocument(doc)">
                        <button
                            mat-icon-button
                            (click)="viewDocument(doc)"
                            matTooltip="View"
                        >
                            <mat-icon>visibility</mat-icon>
                        </button>
                        <button
                            mat-icon-button
                            (click)="downloadDocument(doc)"
                            matTooltip="Download"
                        >
                            <mat-icon>download</mat-icon>
                        </button>
                        <button
                            mat-icon-button
                            (click)="editDocumentType(doc)"
                            matTooltip="Edit Type"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>


            <tbody>
                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns;"
                ></tr>
            </tbody>
        </table>
    </div>


    <div class="upload-section">
        <h3>Upload New Documents</h3>

        <div
            class="upload-area"
            (dragover)="$event.preventDefault()"
            (drop)="onFileDropped($event)"
        >
            <div
                *ngIf="!uploadingFiles || uploadingFiles.length === 0"
                class="drop-zone"
                (click)="fileInput.click()"
            >
                [ Drag and drop files here to be uploaded ]
                <button
                    mat-raised-button
                    color="primary"
                    (click)="selectFiles($event)"
                >
                    Select Files
                </button>
                <input
                    type="file"
                    #fileInput
                    multiple
                    (change)="onFileSelected($event)"
                    style="display: none"
                    (click)="$event.stopPropagation()"
                >
            </div>

            <div
                *ngIf="uploadingFiles && uploadingFiles.length > 0"
                class="upload-preview"
            >
                <div class="files-list">
                    <div
                        *ngFor="let file of uploadingFiles; let i = index"
                        class="file-item"
                        [class.processing]="file.processing"
                        [class.completed]="file.completed"
                    >
                        <div class="file-info">
                            <span class="file-name">{{file.name}}</span>
                            <span class="file-size">{{file.size}}</span>
                            <span class="file-category" *ngIf="file.documentType">
                                Category: {{file.documentType}}
                            </span>
                        </div>
                        <div class="file-actions">
                            <button
                                *ngIf="!file.documentType"
                                mat-icon-button
                                (click)="selectCategoryForFile(i)"
                                color="primary"
                                matTooltip="Select Category"
                            >
                                <mat-icon>category</mat-icon>
                            </button>
                            <button
                                *ngIf="file.documentType && !file.completed"
                                mat-icon-button
                                (click)="uploadFile(i)"
                                color="primary"
                                matTooltip="Upload"
                                [disabled]="file.processing || isUploading()"
                            >
                                <mat-icon *ngIf="!file.processing">cloud_upload</mat-icon>
                                <mat-spinner *ngIf="file.processing" diameter="16"></mat-spinner>
                            </button>
                            <button
                                mat-icon-button
                                (click)="removeFile(i)"
                                color="warn"
                                matTooltip="Remove"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="upload-actions" *ngIf="hasFilesReadyForUpload()">
                    <button
                        mat-raised-button
                        (click)="uploadAllFiles()"
                        color="primary"
                        [disabled]="!hasFilesReadyForUpload() || isUploading()"
                        [class.uploading]="isUploading()"
                    >
                        {{ isUploading() ? 'Uploading...' : 'Upload ' + getFilesReadyCount() + ' File' + (getFilesReadyCount() !== 1 ? 's' : '') }}
                    </button>
                    <button
                        mat-button
                        (click)="clearAllFiles()"
                        color="warn"
                        [disabled]="isUploading()"
                    >
                        Clear All
                    </button>
                </div>
               <!--   <div class="upload-actions" *ngIf="hasFilesWithoutCategory()">
                    <button
                        mat-button
                        (click)="setCategoryForAllFiles()"
                        color="accent"
                        [disabled]="!hasFilesWithoutCategory() || isUploading()"
                    >
                        Set Category for All
                    </button>
                </div> -->
            </div>
        </div>
    </div>
</div>
